// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.GetLandlordStatusWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { GetLandlordStatusRequestDto, GetLandlordStatusResponseDto } from '../..';

export const GetLandlordStatusWebApiHandler_getLandlordStatus_Path = '/api/web/v1/getLandlordStatus';

/**
 * Get landlord status
 */
export const GetLandlordStatusWebApiHandler_getLandlordStatus = (
  postData: GetLandlordStatusRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, GetLandlordStatusRequestDto, GetLandlordStatusResponseDto>(
    {
      endpoint: GetLandlordStatusWebApiHandler_getLandlordStatus_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
